import { render, staticRenderFns } from "./refunds.vue?vue&type=template&id=6b411eb4&scoped=true"
import script from "./refunds.vue?vue&type=script&lang=js"
export * from "./refunds.vue?vue&type=script&lang=js"
import style0 from "./refunds.vue?vue&type=style&index=0&id=6b411eb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b411eb4",
  null
  
)

export default component.exports